import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';

/**
 * Toast properties.
 */

const variantMapper: { [index: string]: string } = {
  primary: 'bg-primary text-light',
  secondary: 'bg-secondary',
  success: 'bg-success text-light',
  info: 'bg-info text-dark',
  warning: 'bg-warning',
  danger: 'bg-danger text-white',
  light: 'bg-light',
  dark: 'bg-dark text-white',
  white: 'bg-white',
};

export interface IToastHeaderProps extends TestingProps {
  children?: React.ReactNode;
  /** This is an example comment that will show up in the docs. */
  variant?: string;
  className?: string;
  onClick?: (
    e?: React.MouseEvent<HTMLButtonElement> | undefined
  ) => void | undefined;
}

/**
 *
 */
export const ToastHeader: React.FC<IToastHeaderProps> = (props) => {
  return (
    <div
      className={C(
        props.className,
        'toast-header',
        'justify-content-between',
        props.variant && variantMapper[props.variant]
      )}
    >
      <h4 className="mb-0 mr-2">{props.children}</h4>
      <button
        type="button"
        className={C('close', props.variant && variantMapper[props.variant])}
        aria-label="Close"
        onClick={props.onClick}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};
